/**
 * Окно «Сравнить» на карточке изображения: куда сдвинуть выбранный вход по
 * стрелке. Края без заворота — на краю ответ `null` (остаёмся на месте).
 */
export function stepIndex(index: number, count: number, key: string): number | null {
  if (key === "ArrowRight") return index + 1 < count ? index + 1 : null;
  if (key === "ArrowLeft") return index - 1 >= 0 && index - 1 < count ? index - 1 : null;
  return null;
}
